<div class="ip-page">
  <div class="ip-content">
    <div class="ip-skeleton" *ngIf="loading" role="status" aria-label="Cargando panel de impacto">
      <div class="hero">
        <div class="sk sk-avatar"></div>
        <div class="hero-info">
          <div class="sk sk-line sk-w40"></div>
          <div class="sk sk-line sk-w25"></div>
          <div class="sk sk-line sk-w55"></div>
        </div>
        <div class="sum-pills">
          <div class="sk sk-pill" *ngFor="let _ of [1, 2, 3]"></div>
        </div>
      </div>
      <div class="tabs-bar sk-tabs">
        <div class="sk sk-tab"></div>
        <div class="sk sk-tab"></div>
      </div>
      <div class="sk-card" *ngFor="let _ of [1, 2, 3]">
        <div class="sk sk-line sk-w55"></div>
        <div class="sk sk-line sk-w40"></div>
      </div>
      <div class="sk sk-line sk-w25 sk-title"></div>
      <div class="sk-card sk-activity">
        <div class="sk sk-line" *ngFor="let _ of [1, 2, 3, 4]"></div>
      </div>
    </div>

    <ng-container *ngIf="!loading">
      <div class="empty-wallet" *ngIf="noWallet">
        Todavía no tenés compromisos vinculados a blockchain.
      </div>

      <div class="load-error" *ngIf="loadError">
        No pudimos cargar tu panel de impacto. Puede ser un problema temporal de conexión.
        <button type="button" class="retry-btn" (click)="retry()">Reintentar</button>
      </div>

      <ng-container *ngIf="!noWallet && !loadError">
        <div class="hero">
          <div class="avatar-lg">{{ heroInitials }}</div>
          <div class="hero-info">
            <div class="user-name">{{ heroDisplayName }}</div>
            <div class="user-meta">{{ heroMeta }}</div>
            <div class="wallet-row">
              <span class="wallet-addr">{{ walletShort }}</span>
              <button class="icon-btn" type="button" (click)="copyWalletAddress()" title="Copiar dirección">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
                  <path
                    d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"
                  />
                </svg>
              </button>
              <span class="copied" *ngIf="copied">¡Copiado!</span>
              <a class="poly-link" [href]="polygonscanUrl" target="_blank" rel="noopener">
                Ver verificación en blockchain ↗
              </a>
            </div>
          </div>
          <div class="sum-pills" *ngIf="summary">
            <div class="sum-pill">
              <span class="sum-n sum-suc">{{ summary.commitments }}</span>
              <span class="sum-l">Compromisos</span>
            </div>
            <div class="sum-pill">
              <span class="sum-n sum-sec">{{ summary.collaborations }}</span>
              <span class="sum-l">Colaboraciones</span>
            </div>
            <div class="sum-pill">
              <span class="sum-n sum-info">{{ summary.documents }}</span>
              <span class="sum-l">Documentos</span>
            </div>
          </div>
        </div>

        <div class="tabs-bar">
          <button
            class="tab-btn"
            type="button"
            [class.active]="activeTab === 'compromisos'"
            (click)="switchTab('compromisos')"
          >
            Compromisos <span class="sec-count">{{ summary?.commitments ?? (commitmentsState === 'ready' ? commitments.length : '…') }}</span>
          </button>
          <button
            class="tab-btn"
            type="button"
            [class.active]="activeTab === 'colaboraciones'"
            (click)="switchTab('colaboraciones')"
          >
            Colaboraciones <span class="sec-count">{{ summary?.collaborations ?? (collaborationsState === 'ready' ? collaborations.length : '–') }}</span>
          </button>
        </div>

        <div class="tab-panel" [hidden]="activeTab !== 'compromisos'">
          <div class="sec-note">creados por este miembro</div>

          <div class="section-loading" *ngIf="commitmentsState === 'loading'">Cargando compromisos…</div>
          <div class="section-error" *ngIf="commitmentsState === 'error'">
            No pudimos cargar los compromisos.
            <button type="button" class="retry-link" (click)="retry()">Reintentar</button>
          </div>

          <ng-container *ngIf="commitmentsState === 'ready'">

          <div class="filters-bar" *ngIf="commitments.length">
            <input
              class="filter-search"
              type="text"
              placeholder="Buscar compromiso…"
              [(ngModel)]="commitmentSearch"
            />
            <select class="filter-select" [(ngModel)]="commitmentStatusFilter">
              <option value="">Todos los estados</option>
              <option *ngFor="let opt of commitmentStatusOptions" [value]="opt.value">{{ opt.label }}</option>
            </select>
            <select class="filter-select" [(ngModel)]="commitmentCommunityFilter" *ngIf="commitmentCommunityOptions.length">
              <option value="">Todas las comunidades</option>
              <option *ngFor="let opt of commitmentCommunityOptions" [value]="opt.value">{{ opt.label }}</option>
            </select>
            <select class="filter-select" [(ngModel)]="commitmentSort">
              <option value="recent">Más recientes</option>
              <option value="oldest">Más antiguos</option>
              <option value="az">Título A-Z</option>
            </select>
            <button
              class="filter-clear"
              type="button"
              *ngIf="hasActiveCommitmentFilters"
              (click)="clearCommitmentFilters()"
            >
              Limpiar filtros
            </button>
          </div>

          <div class="empty" *ngIf="!commitments.length">No hay compromisos registrados</div>
          <div class="empty" *ngIf="commitments.length && !filteredCommitments.length">
            No hay compromisos que coincidan con el filtro
          </div>
          <app-commitment-card
            *ngFor="let commitment of visibleCommitments; trackBy: trackByCommitment"
            [commitment]="commitment"
            [walletAddress]="walletAddress"
          ></app-commitment-card>
          <button
            class="show-more-btn"
            type="button"
            *ngIf="filteredCommitments.length > commitmentLimit"
            (click)="showMoreCommitments()"
          >
            Mostrar más ({{ filteredCommitments.length - commitmentLimit }} restantes)
          </button>
          </ng-container>
        </div>

        <div class="tab-panel" *ngIf="collaborationsState !== 'idle'" [hidden]="activeTab !== 'colaboraciones'">
          <div class="section-loading" *ngIf="collaborationsState === 'loading'">Cargando colaboraciones…</div>
          <div class="section-error" *ngIf="collaborationsState === 'error'">
            No pudimos cargar las colaboraciones.
            <button type="button" class="retry-link" (click)="retry()">Reintentar</button>
          </div>

          <ng-container *ngIf="collaborationsState === 'ready'">
          <div class="filters-bar" *ngIf="collaborations.length">
            <input
              class="filter-search"
              type="text"
              placeholder="Buscar colaboración…"
              [(ngModel)]="collaborationSearch"
            />
            <select class="filter-select" [(ngModel)]="collaborationStatusFilter">
              <option value="">Todos los estados</option>
              <option *ngFor="let opt of collaborationStatusOptions" [value]="opt.value">{{ opt.label }}</option>
            </select>
            <select class="filter-select" [(ngModel)]="collaborationCategoryFilter" *ngIf="collaborationCategoryOptions.length">
              <option value="">Todas las categorías</option>
              <option *ngFor="let opt of collaborationCategoryOptions" [value]="opt.value">{{ opt.label }}</option>
            </select>
            <select class="filter-select" [(ngModel)]="collaborationSort">
              <option value="recent">Más recientes</option>
              <option value="oldest">Más antiguas</option>
              <option value="az">Título A-Z</option>
            </select>
            <button
              class="filter-clear"
              type="button"
              *ngIf="hasActiveCollaborationFilters"
              (click)="clearCollaborationFilters()"
            >
              Limpiar filtros
            </button>
          </div>

          <div class="empty" *ngIf="!collaborations.length">No hay colaboraciones registradas</div>
          <div class="empty" *ngIf="collaborations.length && !filteredCollaborations.length">
            No hay colaboraciones que coincidan con el filtro
          </div>
          <app-collaboration-row
            *ngFor="let collaboration of visibleCollaborations; trackBy: trackByCollaboration"
            [collaboration]="collaboration"
          ></app-collaboration-row>
          <button
            class="show-more-btn"
            type="button"
            *ngIf="filteredCollaborations.length > collaborationLimit"
            (click)="showMoreCollaborations()"
          >
            Mostrar más ({{ filteredCollaborations.length - collaborationLimit }} restantes)
          </button>
          </ng-container>
        </div>

        <div class="sec-mb activity-section">
          <div class="sec-hd">
            <span class="sec-title">Actividad reciente</span>
          </div>
          <div class="section-loading" *ngIf="historyState === 'loading'">Cargando actividad…</div>
          <div class="section-error" *ngIf="historyState === 'error'">
            No pudimos cargar la actividad reciente.
            <button type="button" class="retry-link" (click)="retry()">Reintentar</button>
          </div>
          <ng-container *ngIf="historyState === 'ready'">
          <div class="act-wrap" *ngIf="activity.shown.length; else noActivity">
            <div class="act-row" *ngFor="let event of activity.shown; trackBy: trackByEvent">
              <div
                class="act-date"
                [matTooltip]="formatDateTime(event.date)"
                matTooltipPosition="below"
              >
                <span class="act-date-day">{{ formatDate(event.date) }}</span>
                <span class="act-date-time">{{ formatTime(event.date) }}</span>
              </div>
              <app-activity-event-icon
                class="act-icon"
                [iconKind]="activityIconKind(event)"
                [tone]="activityDotClass(event)"
              ></app-activity-event-icon>
              <div class="act-text">
                {{ activityLabel(event) }}
                <span
                  class="chip"
                  *ngIf="activityStatusChip(event) as chip"
                  [ngClass]="'chip-' + chip.cssClass"
                  >{{ chip.text }}</span
                >
                <app-tx-link
                  [txHash]="event.txHash"
                  [explorerUrl]="event.explorerUrl"
                ></app-tx-link>
              </div>
            </div>
            <div class="act-pager" *ngIf="activityTotalCount > activityPageSize">
              <div class="act-pager-nav">
                <button
                  type="button"
                  class="act-pager-btn"
                  [disabled]="!canGoActivityPrev"
                  (click)="goToActivityPage(activityPage - 1)"
                >
                  Anterior
                </button>
                <ng-container *ngFor="let item of activityPageItems">
                  <span class="act-pager-ellipsis" *ngIf="item === '…'">…</span>
                  <button
                    type="button"
                    class="act-pager-btn act-pager-num"
                    *ngIf="item !== '…'"
                    [class.active]="item === activityPage"
                    [disabled]="loadingMoreHistory"
                    (click)="selectActivityPage(item)"
                  >
                    {{ item }}
                  </button>
                </ng-container>
                <button
                  type="button"
                  class="act-pager-btn"
                  [disabled]="!canGoActivityNext"
                  (click)="goToActivityPage(activityPage + 1)"
                >
                  {{ loadingMoreHistory ? 'Cargando…' : 'Siguiente' }}
                </button>
              </div>
              <span class="act-pager-meta">{{ activityRangeLabel }}</span>
            </div>
          </div>
          <ng-template #noActivity>
            <div class="empty">No hay actividad registrada</div>
          </ng-template>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
